'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");

function LoadMore(Props) {
  var onLoadMoreResults = Props.onLoadMoreResults;
  var onLoadMoreLoading = Props.onLoadMoreLoading;
  var loadMore = Props.loadMore;
  var offset = Props.offset;
  var count = Props.count;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = React.useState(function () {
        return /* WaitingToBeClicked */0;
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (typeof state === "number") {
            if (state !== 0) {
              Debugging$PvpcontrollerWeb.info("Loading");
              Curry._1(onLoadMoreLoading, undefined);
              return Curry._3(loadMore, offset, count, (function (results) {
                            return Curry._1(setState, (function (_previousState) {
                                          return /* Results */{
                                                  _0: results
                                                };
                                        }));
                          }));
            } else {
              Debugging$PvpcontrollerWeb.info("WaitingToBeClicked");
              return ;
            }
          }
          var results = state._0;
          Debugging$PvpcontrollerWeb.info("Results");
          Debugging$PvpcontrollerWeb.info(results);
          Curry._1(onLoadMoreResults, results);
          Curry._1(setState, (function (_previousState) {
                  return /* WaitingToBeClicked */0;
                }));
          
        }), [state]);
  return React.createElement("div", {
              className: className,
              onClick: (function (param) {
                  return Curry._1(setState, (function (_previousState) {
                                return /* Loading */1;
                              }));
                })
            }, typeof state === "number" && state !== 0 ? React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)) : "Load More...");
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7) {
  var tmp = {
    onLoadMoreResults: prim0,
    onLoadMoreLoading: prim1,
    loadMore: prim2,
    offset: prim3,
    count: prim4
  };
  if (prim5 !== undefined) {
    tmp.className = Caml_option.valFromOption(prim5);
  }
  if (prim6 !== undefined) {
    tmp.key = prim6;
  }
  return tmp;
}

var make = LoadMore;

exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
